export default class DateGenerator {
  public static createDate(date: Date): string {
    let day: number | string = date.getUTCDate();
    let month: number | string = date.getUTCMonth() + 1;
    const year: number = date.getUTCFullYear();

    if (day < 10) {
      day = `0${day}`;
    }
    if (month < 10) {
      month = `0${month}`;
    }
    return `${day}.${month}.${year}`;
  }
}
